import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Toaster } from '@app/services';
import { environment } from '@env/environment';
import { LasgroPurchase_order } from 'api/models';
import { UnitService } from 'api/services';
import CustomStore from 'devextreme/data/custom_store';

const isRCDSS = environment.name === 'rcdss';
@Component({
  selector: 'unit',
  templateUrl: './unit.modal.html',
  styleUrls: ['./unit.modal.scss']
})

export class UnitModal implements OnInit {
  @Input() purchaseOrder: LasgroPurchase_order;
  @Input() modal: MatDialogRef<UnitModal>;
  @Input() organizationId: string;
  isCreationMode = false;
  dataSource: any;
  constructor(private unitService: UnitService,
    private toaster: Toaster) { }

  ngOnInit(): void {
    this.dataSource = new CustomStore({
      key: 'id',
      load: () => this.initUnits(),
      insert: (value) => this.addUnit(value),
      update: (key, values) => this.updateUnit({id: key, ...values}),
      remove: (key) => this.deleteUnit(key),
    });

  }

  initUnits() {
    return this.unitService.unitList(this.organizationId)
    .toPromise().then((users: any) => users)
    .catch((error) => {
      console.error(error);
      this.toaster.show('error', 'Users', 'An error occurred, please try again later.');
    });
  }  

  addUnit(data: any) {
    return this.unitService.unitAdd({name: data.name, organizationID: this.organizationId}).toPromise().then((response: any) => {
      this.toaster.show('success', '', `Unit was added successfully`);
    }, (error) => {
      console.error(error);
      this.toaster.show('error', 'Error', 'An error occurred, please try again later.');
    });
  }

  updateUnit(data: any) {
    return this.unitService.unitUpdate(data).toPromise().then((response: any) => {
      this.toaster.show('success', '', `Unit was updated successfully`);
    }).catch((error)  => {
      console.error(error);
      this.toaster.show('error', 'Error', 'An error occurred, please try again later.');
    });
  }

  deleteUnit(id: any) {
    return this.unitService.unitDelete(id).toPromise().then((response: any) => {
      this.toaster.show('success', '', `Unit was deleted successfully`);
    }).catch((error)  => {
      console.error(error);
      this.toaster.show('error', 'Error', 'An error occurred, please try again later.');
    });
  }

  canEdit() {
    return true;
  }

  closeModal() {
    this.modal.close();
  }
}
